<!-- //
SQL子查询页面
@auth xuyd
@date 2024-05-01
//-->
<template>
  <page-layout layout="A|C">
    <div slot="pageAside" style="width: 220px;height: 100%;">
      <div class="flex-row" style="padding-bottom: 5px;">
        <el-input size="small" v-model="searchVal" placeholder="检索数据源">
          <el-button slot="append" @click="handleAdd">添加</el-button>
        </el-input>
      </div>
      <el-scrollbar class="scroll-container">
        <el-tree
            :data="list"
            :props="defaultProps"
            :show-checkbox="false"
            :expand-on-click-node="false"
            node-key="id"
            :current-node-key="currentNodeKey"
            :filter-node-method="filterNode"
            ref="refTree"
            default-expand-all
            highlight-current
            @node-click="handleNodeClick"
        >
          <div class="custom-tree-node" slot-scope="{data, node}">
            <div class="content">
              <i v-if="data.queryType === 'API'" class="el-icon-moon-night" style="color: lightgreen"></i>
              <i v-else-if="data.queryType === 'SQL'" class="el-icon-ice-cream" style="color: red"></i>
              <span class="ml5">{{ node.label }} </span>
            </div>
            <div class="opts">
              <el-button type="text"
                         size="small"
                         icon="el-icon-delete"
                         style="margin-right: 10px;"
                         @click.stop="handleDelete(data)"/>
            </div>
          </div>
        </el-tree>
      </el-scrollbar>
    </div>
    <!-- 结果区域 -->
    <div class="layout-result" style="height: 100%; overflow-x: auto;">
      <el-form @submit.native.prevent ref="refForm"
               :model="form"
               :rules="rules"
               size="small"
               class="form-container flex-column"
               style="flex: 1">
        <el-row class="flex-row flex-valign-center"
                style="height: 40px;
                margin: 0;padding: 0">
          <dict-tag :value="form.queryType" :data="this.$store.getters.dictType['QUERY_TYPE']" :options="{type: 'tag'}"/>
          <span class="ml10" style="font-weight: bold;">{{ form.queryName }}</span>
        </el-row>
        <el-row :gutter="20" style="flex: 1;margin: 0;padding: 0">
          <el-col :span="14" class="flex-column" style="height: 100%; padding-left: 0;">
            <el-form-item prop="dsName" label="" v-if="form.queryType === 'SQL'">
              <div class="flex-row">
                <el-select
                    v-model="form.dsName"
                    placeholder="请选择数据源"
                    clearable
                    style="width: 100%">
                  <el-option
                      v-for="item in this.databaseList"
                      :key="item.text"
                      :label="item.text"
                      :value="item.text"
                  />
                </el-select>
                <div class="flex-row flex-halign-between ml10">
                  <el-button type="primary" size="small" @click="handleSave" :loading="saveLoading">保 存</el-button>
                  <el-button type="danger" size="small" @click="handleTest" :loading="testLoading">测 试</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="api" label="" v-if="form.queryType === 'API'">
              <div class="flex-row">
                <el-input v-model="form.api" clearable maxlength="255" placeholder="请输入API接口">
                  <el-select v-model="form.apiMethod" slot="prepend" style="width: 100px">
                    <el-option v-for="item in this.$store.getters.dictType['API_METHOD']"
                               :key="item.value"
                               :value="item.value">
                      <span :class="item.raw.dictStyle">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </el-input>
                <div class="flex-row flex-halign-between ml10">
                  <el-button type="primary" size="small" @click="handleSave" :loading="saveLoading">保 存</el-button>
                  <el-button type="danger" size="small" @click="handleTest" :loading="testLoading">测 试</el-button>
                </div>
              </div>
            </el-form-item>

            <el-form-item prop="requestParams">
              <ApiQueryParams v-model="form.requestParams" style="max-height: 343px; overflow-y: auto;"/>
            </el-form-item>

            <el-form-item prop="script" v-if="form.queryType === 'SQL'" class="full-item">
              <MonacoEditor v-model="form.script" :options="ruleOptions" @blur="handleEditorChange"/>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="padding:0;height: calc(100% - 35px)">
            <MonacoEditor v-model="result" :options="resultOptions"/>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <AddDlg ref="refAddDlg"/>
  </page-layout>
</template>

<script>
import SqlQueryApi from '@/api/datasvc/sqlQuery.api.js';
import DatasourceApi from '@/api/datasvc/datasource.api.js';
import MonacoEditor from '@/components/Editor/monacoEditor.vue'
import ApiQueryParams from '@/components/Table/FormTable.vue'
import AddDlg from './add';

export default {
  name: 'ViewSqlQuerySupport',
  components: {AddDlg, MonacoEditor, ApiQueryParams},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
    {dictType: 'QUERY_TYPE', dataType: String},
    {dictType: 'API_METHOD', dataType: String},
  ],
  data() {
    return {
      databaseList: [],
      list: [],
      currentNodeKey: null, // 选择的node
      defaultProps: {
        children: 'children',
        label: 'queryName',
      },
      ruleOptions: {languageGroup: 'sql', language: 'pgsql'},
      resultOptions: {language: 'json', value: '{}', autoFormat: true,},
      result: null,
      saveLoading: false,
      deleteLoading: false,
      testLoading: false,
      searchVal: null,
      form: {
        id: null,
        queryType: null,
        requestParams: [],// 请求参数
        responseBody: {},// 返回数据体
        queryName: null,
        script: null,
        api: null,
        apiMethod: 'get',
      },
      rules: {
        dsName: [{required: true, message: "请选择数据源", trigger: 'change'}],
        script: [{required: true, message: "请输入SQL脚本", trigger: 'blur'}],
        api: [{required: true, message: "请输入API接口", trigger: 'blur'}],
      },
    };
  },
  watch: {
    searchVal(val) {
      this.$refs.refTree.filter(val)
    },
  },
  created() {
    this.init();
    this.getList();
  },
  methods: {
    init() {
      DatasourceApi.selectList().then(resp => {
        this.databaseList = resp.data;
      })
    },
    getList() {
      SqlQueryApi.searchList({}).then(resp => {
        this.list = resp.data.records;
        this.total = resp.data.total;
        this.currentNodeKey = this.list[0].id;
        this.getInfo(this.currentNodeKey);
        this.$nextTick(() => {
          this.$refs.refTree.setCurrentKey(this.currentNodeKey);
        });
      })
    },

    getInfo(id) {
      SqlQueryApi.getInfo(id).then(resp => {
        this.form = resp.data;
        console.log("----handleNodeClick---->", resp.data)
      })
    },

    filterNode(value, data) {
      if (!value) return true;
      return data['queryName'].indexOf(value) !== -1;
    },

    handleEditorChange(val) {
      // console.log("----edit blur---->")
      this.$refs.refForm.validateField('script')
    },

    /**
     * 点击节点
     *
     * @param data
     */
    handleNodeClick(data) {
      this.currentNodeKey = data.id;
      this.result = "";
      this.getInfo(this.currentNodeKey);
    },

    /**
     * 新增
     */
    handleAdd() {
      this.$refs.refAddDlg.showModal({
        title: '添加数据源',
        data: {},
        onOk: (data) => {
          this.getList();
        }
      });
    },

    /**
     * 编辑
     */
    handleSave() {
      console.log("-----handleSave-------->", this.form);
      this.$refs.refForm.validate(valid => {
        if (valid) {
          this.$modal.confirm(`确定要保存【${this.form.queryName}】吗？`).then(() => {
            this.saveLoading = true;
            SqlQueryApi.saveInfo(this.form).then(resp => {
              this.saveLoading = false
              this.getInfo(this.form.id);
              this.$modal.msgSuccess('保存成功');
            }).catch(() => {
              this.saveLoading = false;
            })
          })
        }
      });
    },

    /**
     * 删除
     * @param row
     */
    handleDelete(row) {
      this.$modal.confirm(`确定要删除【${row.queryName}】吗？`).then(() => {
        this.deleteLoading = true;
        SqlQueryApi.deleteInfo(row.id).then(resp => {
          this.deleteLoading = false
          this.$modal.msgSuccess('删除成功');
          this.getList();
        }).catch(() => {
          this.deleteLoading = false
        })
      })
    },

    /**
     * 测试
     * @param row
     */
    handleTest(row) {
      this.$refs.refForm.validate(valid => {
        if (valid) {
          this.testLoading = true;
          return SqlQueryApi.execute(this.form).then(resp => {
            this.$modal.msgSuccess('测试OK');
            // console.log(JSON.stringify(retData))
            this.result = JSON.stringify(resp.data);
            this.testLoading = false;
          }).catch(() => {
            this.testLoading = false;
          });
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
//.success {
//  font-weight: 600;
//  font-size: 16px;
//  color: #67c23a !important;
//}
//
//.warning {
//  font-weight: 600;
//  font-size: 16px;
//  color: #ec0f0f !important;
//}
</style>

<style lang="less" scoped>
.scroll-container {
  height: calc(100% - 37px);
  box-sizing: border-box;

  .el-scrollbar__wrap {
    overflow-x: hidden;
    overflow-y: scroll;
  }

  :deep(.el-tree-node) {
  }

  :deep(.el-tree-node__content):hover .opts {
    display: inline-block;
  }

  :deep(.el-tree-node__content) {
    height: 36px;
  }

  .custom-tree-node {
    width: 100%;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .opts {
      display: none;
    }

    .content {
      display: flex;
      align-items: center;
    }
  }
}

.form-container {
  .full-item {
    flex: 1;

    :deep(.el-form-item__content) {
      height: calc(100% - 20px);
    }
  }
}
</style>
